import React from 'react';
import { Link } from 'react-router-dom';
import {
  CONTEXTUAL_SERVICE_LINKS,
  CONTENT_CATEGORIES,
  buildServicesPath,
  getOfferById,
} from '../config/planningOffers';
import { trackLinkClick, trackOfferDetailClick } from '../lib/analytics';

/**
 * Contextual service links for calculators / educational pages.
 * Presents guidance, not an automated recommendation.
 */
export default function ServiceNextStep({
  contentCategory = CONTENT_CATEGORIES.GENERAL,
  className = '',
  calculatorId,
  calculatorName,
  promotionalAngle = 'calculator_next_step',
}) {
  const config = CONTEXTUAL_SERVICE_LINKS[contentCategory]
    || CONTEXTUAL_SERVICE_LINKS[CONTENT_CATEGORIES.GENERAL];

  if (!config || !config.links?.length) return null;

  const handleClick = (link) => {
    const href = buildServicesPath(link.hash);
    const offer = link.offerId ? getOfferById(link.offerId) : null;
    const payload = {
      button_id: `service_next_${contentCategory}_${link.hash || 'services'}`,
      button_label: link.label,
      destination_type: 'internal',
      content_category: contentCategory,
      promotional_angle: promotionalAngle,
      selected_offer: link.offerId || undefined,
      offer_id: link.offerId || undefined,
      pricing_model: offer?.pricingModel,
      calculator_id: calculatorId,
      calculator_name: calculatorName,
    };
    trackLinkClick(href, link.label, payload);
    trackOfferDetailClick(payload);
  };

  return (
    <aside
      className={`service-next-step ${className}`.trim()}
      aria-label="Related planning services"
    >
      <p className="service-next-step-kicker">Related services</p>
      <p className="service-next-step-intro">{config.intro}</p>
      <p className="service-next-step-note">
        This is guidance based on the topic of this page—not an automated recommendation.
      </p>
      <ul className="service-next-step-list">
        {config.links.map((link) => (
          <li key={`${link.hash}-${link.label}`}>
            <Link
              to={buildServicesPath(link.hash)}
              onClick={() => handleClick(link)}
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
}
